/**
 * 랜딩 섹션 앵커 id(SSoT, specs/049) — 헤더 메뉴(`config/nav.ts`)·데스크톱 섹션·모바일 섹션이 모두 이 값을 쓴다.
 * 데스크톱·모바일 구성은 한 번에 하나만 렌더되므로 같은 id 를 공유한다(메뉴가 어느 구성에서든 같은 곳으로 이동).
 * id 는 이동 전용이다 — 스타일은 클래스로만 건다(id 선택자 금지: 두 구성이 id 를 공유하므로 스타일이 섞인다).
 */
export const LANDING_ANCHORS = {
  feed: 'today-feed',
  ask: 'ask',
  audience: 'for-you',
  story: 'story',
  workflow: 'workflow',
  pricing: 'pricing',
  faq: 'faq',
  final: 'final-cta',
} as const;

export type LandingAnchor = keyof typeof LANDING_ANCHORS;

/** 같은 페이지 안 이동 링크(`#id`). */
export function anchorHash(anchor: LandingAnchor): string {
  return `#${LANDING_ANCHORS[anchor]}`;
}

/** 다른 페이지에서 랜딩 섹션으로 가는 경로(`/#id`) — 헤더 메뉴용. */
export function landingAnchorRoute(anchor: LandingAnchor): string {
  return `/${anchorHash(anchor)}`;
}
